import { render, staticRenderFns } from "./BackupListCreate.vue?vue&type=template&id=5e8f740b"
import script from "./BackupListCreate.vue?vue&type=script&lang=js"
export * from "./BackupListCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports